import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-244" data-mp="3kregelf94grj">
      <Navbar data-id="element-245" data-mp="2wzzcwpbqntep" />
      <main className="flex-grow" data-id="element-246" data-mp="2wzpo352fjsal">
        <Hero data-id="element-247" data-mp="2x0s9ixgzh2j4" />
        <Services data-id="element-248" data-mp="2wy64p5lh914l" />
        <WhyChooseUs data-id="element-249" data-mp="2s1o2acdmdevf" />
        <Contact data-id="element-250" data-mp="2s27c15t48wyd" />
      </main>
      <Footer data-id="element-251" data-mp="2s2z3c4fok8iu" />
    </div>;
}